export default __webpack_public_path__ + "assets/models/0df0ab61f9c67ac731d3ec02c046c643.glb";